import React from "react";
import { Box, Switch, Typography } from "@mui/material";
import theme from "../../../utils/theme";

export interface IPermissionItems {
  id?: number;
  name: string;
  enabled: boolean;
}

export const PERMISSIONS: Record<string, string> = {
  INDEX_HEALTH_EQUITY: "Enables Health Equity Index in SurgoApp",
  INDEX_HEALTH_EQUITY_TAKEDA: "Enables Takeda's Health Spectrum Index (percentiles) in SurgoApp",
  INDEX_CONTRACEPTIVE: "Enables Contraceptive Index in SurgoApp",
  INDEX_MATERNAL_VULNERABILITY: "Enables Maternal Vulnerability Index in SurgoApp",
  INDEX_DISEASE_BURDEN: "Enables Disease Burden Data Index in SurgoApp",
  INDEX_TRIALS: "Enables Trials Data Library in SurgoApp",
  FEATURE_TRIAL_DASHBOARD: "Enables Trial Center feature access in SurgoApp",
  EXPORT_DEFAULT_ALL_FIELDS: "Turns every export field on by default in SurgoApp",
};

export const getInitialPermissions = (): Record<string, IPermissionItems> => {
  return Object.keys(PERMISSIONS).reduce((acc, key) => {
    acc[key] = { name: key, enabled: false };
    return acc;
  }, {} as Record<string, IPermissionItems>);
};

interface IPermissionsTable {
  permissions: Record<string, IPermissionItems>;
  onToggle: (e: React.ChangeEvent<HTMLInputElement>, permissionName: string) => void;
}

const PermissionsTable = ({ permissions, onToggle }: IPermissionsTable) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {Object.entries(PERMISSIONS).map(([key, description]) => (
        <Box
          key={key}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "12px 16px",
            borderRadius: "8px",
            border: "1px solid",
            borderColor: permissions[key]?.enabled ? theme.palette.brand.secondary : "#E0E0E0",
            backgroundColor: permissions[key]?.enabled ? "#F7FDFC" : "#FFFFFF",
            transition: "all 0.15s ease",
          }}
        >
          <Box sx={{ flex: 1, mr: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, color: "#1E1E1E" }}>
              {key.replace(/_/g, " ")}
            </Typography>
            <Typography variant="caption" sx={{ color: "#878787" }}>
              {description}
            </Typography>
          </Box>
          <Switch
            checked={permissions[key]?.enabled}
            onChange={(e) => onToggle(e, key)}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": { color: theme.palette.brand.success },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: theme.palette.brand.secondary },
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default PermissionsTable;
